const ATS_COLLECTION = "ats";

const extractSnapshotData = (snap) => {
  if (!snap.exists) {
    return null;
  }

  return {
    id: snap.id,
    ...snap.data()
  };
};

function AtsMixin() {
  return {
    async updateAts(campaignId, data) {
      await this.collection(ATS_COLLECTION).doc(campaignId).set(data, { merge: true });
      return { campaignId, ...data };
    },

    async getAtsById(campaignId) {
      const snap = await this.collection(ATS_COLLECTION).doc(campaignId).get();
      return extractSnapshotData(snap);
    },

    async getAtsByOrgaId(orgaId, { limit = null }) {
      let query = this.collection(ATS_COLLECTION).where("orgaId", "==", orgaId);

      if (limit) {
        query = query.limit(limit);
      }

      const snap = await query.get();
      return snap.docs.map((doc) => extractSnapshotData(doc));
    },

    async createAts(campaignId, data) {
      const snap = await this.collection(ATS_COLLECTION).doc(campaignId).set(data);
      return { ...data, id: snap.id };
    }
  };
}

module.exports = AtsMixin;
